import {
  put,
  call,
  takeLatest,
  takeEvery } from 'redux-saga/effects';
import {
  ADMIN_SCORE_FETCH_ALL,
  ADMIN_SCORE_FETCH,
  ADMIN_SCORE_UPDATE
} from './constants';
import {
  fetchScoresSuccess,
  fetchScoresFail,
  fetchScoreSuccess,
  fetchScoreFail,
  updateScoreSuccess,
  updateScoreFail
} from './actions';
import { parseApiError } from '../../util/api';
import ScoreAdminAPI from './ScoreAdminAPI';
import { showNotification } from '../../notifications/actions';

function *fetchScores () {
  try {
    const { data } = yield call(ScoreAdminAPI.fetchScores);
    if (data && Array.isArray(data.scores)) {
      yield put(fetchScoresSuccess(data.scores));
    } else {
      let msg = 'unexpected response fetching scores';
      yield put(fetchScoresFail(msg));
      yield put(showNotification(
        'Failed to load scores', msg, 'error', 10
      ));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchScoresFail(msg));
    yield put(showNotification(
      'Failed to load scores', msg, 'error', 10
    ));
  }
}

function *fetchScore (action) {
  try {
    const { data } = yield call(ScoreAdminAPI.fetchScore, action.scoreId);
    if (data && data.score) {
      yield put(fetchScoreSuccess(data.score));
    } else {
      let msg = 'unexpected response fetching score';
      yield put(fetchScoreFail(msg));
      yield put(showNotification(
        'Failed to load score', msg, 'error', 10
      ));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchScoreFail(msg));
    yield put(showNotification(
      'Failed to load score', msg, 'error', 10
    ));
  }
}

function *updateScore (action) {
  try {
    yield call(ScoreAdminAPI.updateScore, action.score);
    yield put(updateScoreSuccess(action.score));
    yield put(showNotification(
      'Success', `${action.score.name || action.score.email} saved`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(updateScoreFail(msg, action.score));
    yield put(showNotification(
      `Failed to update score ${action.score.name || action.score.email}`,
      msg,
      'error',
      10
    ));
  }
}

function *adminScoreSagas () {
  yield takeLatest(ADMIN_SCORE_FETCH_ALL, fetchScores);
  yield takeLatest(ADMIN_SCORE_FETCH, fetchScore);
  yield takeEvery(ADMIN_SCORE_UPDATE, updateScore);
}

export default adminScoreSagas;
